import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {getProvider,postProvider, getProviderbyId,updateProvider,
   deleteProvider,exportProvider,getProvierStatus,getRequestStatus,getWeightUnit,getParcelType,getUserStatus,getFlagType,
   postDimensions,updateDimensions,deleteDimensions,postCities,updateCities,deleteCities,postUser,
   updateStatus,getPasswordbyId,updatePassword,getUserbyProviderCode,filterProviderbyCode,
   postFlags,getFlagsbyId,updateFlags,deleteUser,exportFlags,resolveFlags,getFlags,printFlag,getFlagStatus,
   getRequests,postRequest,exportRequest,deleteRequest,editRequest,trackRequests,
   getPlTasks,postPlTasks,PlTasksExport,importParcelLockerRequest,getPlReasonType,getPlTasksType,parcelLockerRequestTemplate,deletePlTasks,getPlStatus,getPaymentLink,listPlCouriersbyProvider,importBulkAssign,bulkAssignTemplate,importBulkUnassign,bulkUnassignTemplate,importUserManagementBulk,userManagementBulkTemplate} from "../../services/ParcelLockers/PlLocker_services";
const initialValues = {
   providerStatusList: [],
   providerList: [],
   weightUnitList: [],
   parcelTypeList: [],
   userStatusList: [],
   flagTypeList: [],
   flagStatusList: [],
   plReasonTypeList: [],
   plTasksTypeList: [],
   requestStatusList : [],
   plStatusList: []
};
let parcelStore = (set) => ({
  ...initialValues,
  getProvider: async (params) => {
        const response = await getProvider(params);
        set({ providerList: response });
        return response;
      },
      postProvider: async (data) => {
        const response = await postProvider(data);
        return response;
      },
      getProviderbyId: async (data) => { 
        const response = await getProviderbyId(data);
        return response;
      },
      updateProvider: async (params) => {
        const response = await updateProvider(params);
        return response;
      },
      deleteProvider: async (params) => {
        const response = await deleteProvider(params);
        return response;
      },
      exportProvider: async (params) => {
         const response = await exportProvider(params);
         return response;
       },
       getProvierStatus: async () => {
        const response = await getProvierStatus();
        set({ providerStatusList: response });
        return response;
      },
      getRequestStatus: async () => {
        const response = await getRequestStatus();
        set({ requestStatusList: response });
        return response;
      },
      getWeightUnit: async () => {
        const response = await getWeightUnit();
        set({ weightUnitList: response });
        return response;
      },
      getParcelType: async () => {
        const response = await getParcelType();
        set({ parcelTypeList: response });
        return response;
      },
      getUserStatus: async () => {
         const response = await getUserStatus();
         set({ userStatusList: response });
         return response;
       },
       postDimensions: async (params) => {
        const response = await postDimensions(params);
        return response;
      },
      getFlagType: async (params) => {
         const response = await getFlagType(params);
         set({ flagTypeList: response });
         return response;
       },
       getFlagStatus: async (params) => {
         const response = await getFlagStatus(params);
         set({ flagStatusList: response });
         return response;
       },
         getPlReasonType: async (params) => {
         const response = await getPlReasonType(params);
         set({ plReasonTypeList: response });
         return response;
       },
          getPlTasksType: async (params) => {
         const response = await getPlTasksType(params);
         set({ plTasksTypeList: response });
         return response;
       },
       updateDimensions: async (params,data) => {
         const response = await updateDimensions(params,data);
         return response;
       },
       deleteDimensions: async (params) => {
         const response = await deleteDimensions(params);
         return response;
       },
       postCities: async (params) => {
         const response = await postCities(params);
         return response;
       },
       updateCities: async (params,data) => {
         const response = await updateCities(params,data);
         return response;
       },
       deleteCities: async (params) => {
         const response = await deleteCities(params);
         return response;
       },
       postUser: async (params) => {
         const response = await postUser(params);
         return response;
       },
       deleteUser: async (params) => {
        const response = await deleteUser(params);
        return response;
      },
       updateStatus: async (params,data) => {
         const response = await updateStatus(params,data);
         return response;
       },
       getPasswordbyId: async (params) => {
         const response = await getPasswordbyId(params);
         return response;
       },
       updatePassword: async (params,data) => {
         const response = await updatePassword(params,data);
         return response;
       },
       getUserbyProviderCode: async (params) => {
         const response = await getUserbyProviderCode(params);
         return response;
       },
       filterProviderbyCode: async (data) => {
         const response = await filterProviderbyCode(data);
         return response;
       },
       getFlags: async (params) => {
        const response = await getFlags(params);
        return response;
      },
      postFlags: async (params) => {
        const response = await postFlags(params);
        return response;
      },
      getFlagsbyId: async (params) => {
        const response = await getFlagsbyId(params);
        return response;
      },
      updateFlags: async (params,data) => {
        const response = await updateFlags(params,data);
        return response;
      },
      resolveFlags: async (params) => {
        const response = await resolveFlags(params);
        return response;
      },
      exportFlags: async (params) => {
        const response = await exportFlags(params);
        return response;
      },
      printFlag: async (params) => {
        const response = await printFlag(params);
        return response;
      },
      getRequests: async (params) => {
        const response = await getRequests(params);
        return response;
      },
      postRequest: async (params) => {
        const response = await postRequest(params);
        return response;
      },
      exportRequest: async (params) => {
        const response = await exportRequest(params);
        return response;
      },
      deleteRequest: async (params) => {
        const response = await deleteRequest(params);
        return response;
      },
      editRequest: async (params,data) => {
        const response = await editRequest(params,data);
        return response;
      },
      trackRequests: async (params) => {
        const response = await trackRequests(params);
        return response;
      },
      getPlTasks: async (params) => {
        const response = await getPlTasks(params);
        return response;
      },
      postPlTasks: async (params) => {
        const response = await postPlTasks(params);
        return response;
      },
      PlTasksExport: async (params) => {
        const response = await PlTasksExport(params);
        return response;
      },
      deletePlTasks: async (params) => {
        const response = await deletePlTasks(params);
        return response;
      },
      getPaymentLink: async (params) => {
        const response = await getPaymentLink(params);
        return response;
      },
      getPlStatus: async (params) => {
        const response = await getPlStatus(params);
        set({ plStatusList: response });
        return response;
      },
      listPlCouriersbyProvider: async (data) => {
        const response = await listPlCouriersbyProvider(data);
        return response;
      },
        importBulkAssign: async (data) => {
        const response = await importBulkAssign(data);
        return response;
      },
        bulkAssignTemplate: async (data) => {
        const response = await bulkAssignTemplate(data);
        return response;
      },
        importBulkUnassign: async (data) => {
        const response = await importBulkUnassign(data);
        return response;
      },
        bulkUnassignTemplate: async (data) => {
        const response = await bulkUnassignTemplate(data);
        return response;
      },
        importUserManagementBulk: async (params,data) => {
        const response = await importUserManagementBulk(params,data);
        return response;
      },
        userManagementBulkTemplate: async (data) => {
        const response = await userManagementBulkTemplate(data);
        return response;
      },
        parcelLockerRequestTemplate: async (data) => {
        const response = await parcelLockerRequestTemplate(data);
        return response;
      },
        importParcelLockerRequest: async (data) => {
        const response = await importParcelLockerRequest(data);
        return response;
      },
});

parcelStore = devtools(parcelStore);

export const usePlLockerStore = create(parcelStore);